export var GameAction = /*#__PURE__*/ function(GameAction) {
    GameAction[GameAction["GameChatSubmit"] = 0] = "GameChatSubmit";
    GameAction[GameAction["SkippedWelcome"] = 1] = "SkippedWelcome";
    GameAction[GameAction["ClickedDice"] = 2] = "ClickedDice";
    GameAction[GameAction["SelectedTile"] = 3] = "SelectedTile";
    GameAction[GameAction["SelectedTiles"] = 4] = "SelectedTiles";
    GameAction[GameAction["SelectedPlayer"] = 5] = "SelectedPlayer";
    GameAction[GameAction["PassedTurn"] = 6] = "PassedTurn";
    GameAction[GameAction["SelectedCards"] = 7] = "SelectedCards";
    GameAction[GameAction["SelectedCardsState"] = 8] = "SelectedCardsState";
    GameAction[GameAction["BuyDevelopmentCard"] = 9] = "BuyDevelopmentCard";
    GameAction[GameAction["WantToBuildRoad"] = 10] = "WantToBuildRoad";
    GameAction[GameAction["ConfirmBuildRoad"] = 11] = "ConfirmBuildRoad";
    GameAction[GameAction["ConfirmBuildRoadSkippingSelection"] = 12] = "ConfirmBuildRoadSkippingSelection";
    GameAction[GameAction["ConfirmRemoveRoad"] = 13] = "ConfirmRemoveRoad";
    GameAction[GameAction["WantToBuildSettlement"] = 14] = "WantToBuildSettlement";
    GameAction[GameAction["ConfirmBuildSettlement"] = 15] = "ConfirmBuildSettlement";
    GameAction[GameAction["ConfirmBuildSettlementSkippingSelection"] = 16] = "ConfirmBuildSettlementSkippingSelection";
    GameAction[GameAction["WantToBuildCity"] = 17] = "WantToBuildCity";
    GameAction[GameAction["ConfirmBuildCity"] = 18] = "ConfirmBuildCity";
    GameAction[GameAction["ConfirmBuildCitySkippingSelection"] = 19] = "ConfirmBuildCitySkippingSelection";
    GameAction[GameAction["WantToBuildShip"] = 20] = "WantToBuildShip";
    GameAction[GameAction["ConfirmBuildShip"] = 21] = "ConfirmBuildShip";
    GameAction[GameAction["ConfirmBuildShipSkippingSelection"] = 22] = "ConfirmBuildShipSkippingSelection";
    GameAction[GameAction["WantToMoveShip"] = 23] = "WantToMoveShip";
    GameAction[GameAction["SelectedShipToMove"] = 24] = "SelectedShipToMove";
    GameAction[GameAction["ConfirmMoveShip"] = 25] = "ConfirmMoveShip";
    GameAction[GameAction["WantToBuildCityWall"] = 26] = "WantToBuildCityWall";
    GameAction[GameAction["ConfirmBuildCityWall"] = 27] = "ConfirmBuildCityWall";
    GameAction[GameAction["ConfirmBuildCityWallSkippingSelection"] = 28] = "ConfirmBuildCityWallSkippingSelection";
    GameAction[GameAction["WantToPlaceKnight"] = 29] = "WantToPlaceKnight";
    GameAction[GameAction["ConfirmPlaceKnight"] = 30] = "ConfirmPlaceKnight";
    GameAction[GameAction["ConfirmPlaceKnightSkippingSelection"] = 31] = "ConfirmPlaceKnightSkippingSelection";
    GameAction[GameAction["WantToUpgradeKnight"] = 32] = "WantToUpgradeKnight";
    GameAction[GameAction["ConfirmUpgradeKnight"] = 33] = "ConfirmUpgradeKnight";
    GameAction[GameAction["ConfirmUpgradeKnightSkippingSelection"] = 34] = "ConfirmUpgradeKnightSkippingSelection";
    GameAction[GameAction["WantToActivateKnight"] = 35] = "WantToActivateKnight";
    GameAction[GameAction["ConfirmActivateKnight"] = 36] = "ConfirmActivateKnight";
    GameAction[GameAction["ConfirmActivateKnightSkippingSelection"] = 37] = "ConfirmActivateKnightSkippingSelection";
    GameAction[GameAction["WantToTakeKnightAction"] = 38] = "WantToTakeKnightAction";
    GameAction[GameAction["SelectKnightToTakeAction"] = 39] = "SelectKnightToTakeAction";
    GameAction[GameAction["ConfirmMoveKnight"] = 40] = "ConfirmMoveKnight";
    GameAction[GameAction["ConfirmMoveKnightOffTurn"] = 41] = "ConfirmMoveKnightOffTurn";
    GameAction[GameAction["ConfirmRemoveKnight"] = 42] = "ConfirmRemoveKnight";
    GameAction[GameAction["ConfirmCityUpgrade"] = 43] = "ConfirmCityUpgrade";
    GameAction[GameAction["ConfirmBuildMetropolis"] = 44] = "ConfirmBuildMetropolis";
    GameAction[GameAction["ConfirmPillageCity"] = 45] = "ConfirmPillageCity";
    GameAction[GameAction["ConfirmDicePair"] = 46] = "ConfirmDicePair";
    GameAction[GameAction["CancelAction"] = 47] = "CancelAction";
    GameAction[GameAction["ClickedDevelopmentCard"] = 48] = "ClickedDevelopmentCard";
    // trade
    GameAction[GameAction["CreateTrade"] = 49] = "CreateTrade";
    GameAction[GameAction["UpdateTradeResponse"] = 50] = "UpdateTradeResponse";
    GameAction[GameAction["ExecuteTrade"] = 51] = "ExecuteTrade";
    GameAction[GameAction["ToggledEmbargo"] = 52] = "ToggledEmbargo";
    //
    GameAction[GameAction["RequestActionSwap"] = 53] = "RequestActionSwap";
    GameAction[GameAction["TogglePause"] = 54] = "TogglePause";
    GameAction[GameAction["LeaveGame"] = 55] = "LeaveGame";
    GameAction[GameAction["Resign"] = 56] = "Resign";
    // Special Build Phase
    GameAction[GameAction["RequestSpecialBuildPhase"] = 57] = "RequestSpecialBuildPhase";
    GameAction[GameAction["CancelSpecialBuildPhase"] = 58] = "CancelSpecialBuildPhase";
    GameAction[GameAction["ClickedRematch"] = 59] = "ClickedRematch";
    GameAction[GameAction["Vote"] = 60] = "Vote";
    GameAction[GameAction["Pong"] = 61] = "Pong";
    GameAction[GameAction["RequestBeginnerHint"] = 62] = "RequestBeginnerHint";
    GameAction[GameAction["SkipWelcomeAction"] = 63] = "SkipWelcomeAction";
    GameAction[GameAction["RequestBeginnerModeLevelEnd"] = 64] = "RequestBeginnerModeLevelEnd";
    GameAction[GameAction["StressTestGracefulShutdown"] = 65] = "StressTestGracefulShutdown";
    GameAction[GameAction["SelectedInitialPlacementIndex"] = 66] = "SelectedInitialPlacementIndex";
    GameAction[GameAction["RequestGameState"] = 67] = "RequestGameState";
    GameAction[GameAction["NotifyBackendClientAutoReconnected"] = 68] = "NotifyBackendClientAutoReconnected";
    GameAction[GameAction["ReportPlayer"] = 69] = "ReportPlayer";
    return GameAction;
}({});
